import './IntegrationsSection.css';
import { OpenAIIcon, SlackIcon, SalesforceIcon, WooCommerceIcon, WebhookIcon, ApiIcon, EmailIcon } from '../ui/IntegrationIcons';

const INTEGRATIONS = [
  { name: 'OpenAI',        Icon: OpenAIIcon,       color: '#10A37F' },
  { name: 'Google Gemini', slug: 'googlegemini',   color: '#4285F4' },
  { name: 'Claude AI',     slug: 'anthropic',      color: '#D4723A' },
  { name: 'Shopify',       slug: 'shopify',        color: '#96BF48' },
  { name: 'WooCommerce',   Icon: WooCommerceIcon,  color: '#7F54B3' },
  { name: 'Zapier',        slug: 'zapier',         color: '#FF4A00' },
  { name: 'Google Sheets', slug: 'googlesheets',   color: '#34A853' },
  { name: 'HubSpot',       slug: 'hubspot',        color: '#FF7A59' },
  { name: 'Stripe',        slug: 'stripe',         color: '#635BFF' },
  { name: 'Salesforce',    Icon: SalesforceIcon,   color: '#00A1E0' },
  { name: 'Slack',         Icon: SlackIcon,        color: '#E01E5A' },
  { name: 'Calendly',      slug: 'calendly',       color: '#006BFF' },
  { name: 'SMTP Email',    Icon: EmailIcon,        color: '#EA4335' },
  { name: 'Webhooks',      Icon: WebhookIcon,      color: '#6366F1' },
  { name: 'REST API',      Icon: ApiIcon,          color: '#0EA5E9' },
];

const ROW1 = [...INTEGRATIONS, ...INTEGRATIONS];
const ROW2 = [...INTEGRATIONS.slice(7), ...INTEGRATIONS, ...INTEGRATIONS.slice(0, 7)];

function IntegrationChip({ item }) {
  return (
    <div className="integration-chip" title={item.name} style={{ '--chip-color': item.color }}>
      <span className="integration-chip__logo">
        {item.Icon
          ? <item.Icon size={18} />
          : <img
              src={`https://cdn.simpleicons.org/${item.slug}/${item.color.slice(1)}`}
              alt={item.name}
              width="18"
              height="18"
              loading="lazy"
              onError={e => { e.target.style.display = 'none'; }}
            />
        }
      </span>
      <span className="integration-chip__name">{item.name}</span>
    </div>
  );
}

export default function IntegrationsSection() {
  return (
    <section className="integrations section">
      <div className="container">
        <div className="integrations__header">
          <span className="badge badge-accent">Integrations</span>
          <h2 className="display-lg integrations__title">
            Connects to the tools<br />
            <span className="gradient-text">you already use</span>
          </h2>
          <p className="integrations__sub text-lg">
            Shopify, WooCommerce, OpenAI, Gmail, and more.
            Zepliq plugs directly into your existing stack with no technical setup required.
          </p>
        </div>
      </div>

      <div className="integrations__marquee-wrap">
        <div className="integrations__fade integrations__fade--left"  aria-hidden="true" />
        <div className="integrations__fade integrations__fade--right" aria-hidden="true" />

        <div className="integrations__track integrations__track--row1" aria-hidden="true">
          {ROW1.map((item, i) => <IntegrationChip key={i} item={item} />)}
        </div>
        <div className="integrations__track integrations__track--row2" aria-hidden="true">
          {ROW2.map((item, i) => <IntegrationChip key={i} item={item} />)}
        </div>
      </div>

      <div className="container">
        <div className="integrations__cta">
          <p className="text-sm integrations__cta-text">
            <span className="integrations__dot" />
            Need a custom integration? Use our REST API &amp; Webhooks.
          </p>
          <a href="/contact" className="btn btn-secondary btn-sm">View API Docs</a>
        </div>
      </div>
    </section>
  );
}
